// PastoralBlocks — exibição canônica do devocional em seis seções (contrato v1.1).
// Títulos em versalete simples. Campo vazio = silêncio elegante (seção some).
import React from "react";

const SECTIONS = [
  { key: "abertura", label: "Abertura" },
  { key: "palavra", label: "Palavra" },
  { key: "verdade", label: "Verdade" },
  { key: "hoje", label: "Hoje" },
  { key: "oracao", label: "Oração" },
  { key: "frase_compartilhar", label: "Frase para compartilhar" },
];

export const pastoralBlocksHasContent = (blocks) => {
  if (!blocks || typeof blocks !== "object") return false;
  return SECTIONS.some(({ key }) => {
    const v = blocks[key];
    if (key === "palavra") return !!(v && (v.text || v.reference));
    return typeof v === "string" && v.trim().length > 0;
  });
};

export const pastoralBlocksToText = (blocks) => {
  if (!blocks) return "";
  const parts = [];
  for (const { key } of SECTIONS) {
    const v = blocks[key];
    if (key === "palavra" && v && (v.text || v.reference)) {
      parts.push([v.reference, v.text].filter(Boolean).join(". "));
    } else if (typeof v === "string" && v.trim()) {
      parts.push(v.trim());
    }
  }
  return parts.join("\n\n");
};

export const PastoralBlocks = ({ blocks, testidPrefix = "pastoral-block" }) => {
  if (!pastoralBlocksHasContent(blocks)) return null;
  return (
    <div className="space-y-7" data-testid={`${testidPrefix}s`}>
      {SECTIONS.map(({ key, label }) => {
        const v = blocks[key];
        if (key === "palavra") {
          if (!v || (!v.text && !v.reference)) return null;
          return (
            <div key={key} data-testid={`${testidPrefix}-${key}`}>
              <p className="text-[10px] uppercase tracking-[0.3em] text-navy/55">{label}</p>
              {v.reference && (
                <p className="mt-2 text-xs uppercase tracking-widest text-gold tabular-nums">{v.reference}</p>
              )}
              {v.text && (
                <p className="mt-2 text-navy/90 italic text-[15px] sm:text-base leading-[1.8] whitespace-pre-wrap">
                  {v.text}
                </p>
              )}
            </div>
          );
        }
        if (typeof v !== "string" || !v.trim()) return null;
        if (key === "frase_compartilhar") {
          return (
            <div
              key={key}
              data-testid={`${testidPrefix}-${key}`}
              className="border-l-2 border-gold/60 pl-4 py-1"
            >
              <p className="text-[10px] uppercase tracking-[0.3em] text-navy/55">{label}</p>
              <p className="mt-2 font-display text-lg sm:text-xl text-navy leading-snug">{v}</p>
            </div>
          );
        }
        return (
          <div key={key} data-testid={`${testidPrefix}-${key}`}>
            <p className="text-[10px] uppercase tracking-[0.3em] text-navy/55">{label}</p>
            <p
              className={`mt-2 text-navy/85 text-[15px] sm:text-base leading-[1.75] whitespace-pre-wrap ${key === "oracao" ? "italic" : ""} ${["abertura", "verdade", "hoje"].includes(key) ? "devotional-justify" : ""}`}
            >
              {v}
            </p>
          </div>
        );
      })}
    </div>
  );
};
